module.exports = __webpack_public_path__ + "img/avatar2.e0b72710.png";